// extracted by css-extract-rspack-plugin
export default {"caption":"_a8facdcd","photo":"_16907d4f"};